import type { SchedulePreset } from "../schedule-presets/schedule-presets";
import { format } from "date-fns";
import type { StreamSlot } from "../../stores/schedule-store";

type ArtSources = Pick<SchedulePreset, "base" | "single" | "double" | "offline">;

export function scheduleArtSources(preset: ArtSources, week: Date[], slots: Record<string, StreamSlot>) {
  const daySources = scheduleDayArtSources(preset, week, slots);
  return [preset.base, ...daySources.filter((source) => source !== undefined)];
}

export function scheduleDayArtSources(preset: ArtSources, week: Date[], slots: Record<string, StreamSlot>) {
  return week.map((date, index) => {
    const key = format(date, "yyyy-MM-dd");
    const count = [1, 2].filter(number => slots[`${key}-${number}`]?.active).length;
    if (count === 2) return preset.double[index];
    if (count === 1) return preset.single[index];
    return preset.offline[index];
  });
}

const images = new Map<string, Promise<HTMLImageElement>>();

export function loadArtImage(source: string) {
  if (!images.has(source)) {
    images.set(source, new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        image.decode().then(() => resolve(image)).catch(() => {
          images.delete(source);
          reject(new Error("Could not decode schedule artwork"));
        });
      };
      image.onerror = () => {
        images.delete(source);
        reject(new Error("Could not load schedule artwork"));
      };
      image.src = source;
    }));
  }
  return images.get(source)!;
}
